<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" destroy-on-close>
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="商品名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入商品名称"/>
      </a-form-model-item>
      <a-form-model-item label="免费兑换" prop="freeExchange">
        <a-radio-group v-model="form.freeExchange">
          <a-radio :value="0">否</a-radio>
          <a-radio :value="1">是</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="商品主图" prop="image" >
        <file-upload type="image" :defaultList="form.imageArr" :count="1"
                     @input="getImg($event, 'image')"></file-upload>
        <span style="color: red">建议上传图片尺寸：375*375</span>
      </a-form-model-item>
      <a-form-model-item label="商品轮播图" prop="carouselImage" >
        <file-upload type="image" :defaultList="form.carouselImageArr" :count="6"
                     @input="getImg($event, 'carouselImage')"></file-upload>
        <span style="color: red">建议上传图片尺寸：375*375</span>
      </a-form-model-item>
<!--      <a-form-model-item label="库存" prop="stock" >-->
<!--        <a-input v-model="form.stock" placeholder="请输入库存" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="兑换花费果实数" prop="fruitNum" >
        <a-input-number style="width: 300px" v-model="form.fruitNum" placeholder="请输入兑换花费果实数" />
      </a-form-model-item>
      <a-form-model-item label="商品详情" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGoods, addGoods, updateGoods } from '@/api/goods/goods'
import Editor from '@/components/Editor'
import {guid} from "@/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        name: null,
        image: null,
        freeExchange:null,
        imageArr:[],
        imageCount:1,
        carouselImage: null,
        carouselImageArr:[],
        carouselImageCount:6,
        stock: null,
        fruitNum: null,
        exchangeNum: null,
        content: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '商品名称不能为空', trigger: 'blur' }
        ],
        // image: [
        //   { required: true, message: '商品主图不能为空', trigger: 'blur' }
        // ],
        // imageArr: [
        //   { required: true, message: '商品轮播图不能为空', trigger: 'blur' }
        // ],
        // stock: [
        //   { required: true, message: '库存不能为空', trigger: 'blur' }
        // ],
        fruitNum: [
          { required: true, message: '兑换花费果实数不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        freeExchange:null,
        image: null,
        imageArr:[],
        imageCount:1,
        carouselImage: null,
        carouselImageArr:[],
        carouselImageCount:6,
        // stock: null,
        fruitNum: null,
        exchangeNum: null,
        content: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGoods({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        let that = this;
        if(this.form.image){
          this.form.imageArr = []
          this.form.imageArr.push({
            uid: guid(8, 10),
            name: that.form.image,
            status: 'done',
            halfUrl: that.form.image,
            url: that.form.image,
            path: that.form.image
          })
        }
        if(this.form.carouselImage){
          this.form.carouselImageArr= []
          this.form.carouselImage.split(',').forEach(item =>{
            that.form.carouselImageArr.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: item,
              path: item
            })
          })
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateGoods(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addGoods(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
